
import {
  defineComponent,
  toRefs,
  computed,
  ref,
  watch,
  ComputedRef,
  onBeforeMount
} from "vue";
import TextInput from "../../components/application/inputs/TextInput.vue";
import TUIViewer from "../../components/application/TUIViewer.vue";
import { useStore } from "vuex";
import { Information } from "../../../../domain/entities/information";
import { dispatchErrorBox } from "../../components/mixins";

export default defineComponent({
  name: "InfoPanel",
  components: { TextInput, TUIViewer },
  props: {
    isVisible: { type: Boolean, default: false },
    fetchInformations: { type: Function, required: true }
  },
  setup(props, { emit }) {
    const { isVisible, fetchInformations } = toRefs(props);
    const store = useStore();
    const openItems = ref<boolean[]>([]);
    const searchQuery = ref("");

    const informations: ComputedRef<Information[]> = computed(
      () => store.getters["information_module/informations"] || []
    );

    const filteredInformations = computed(() => {
      if (!searchQuery.value) return informations.value;
      return informations.value.filter(item =>
        item.question.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const toggleInfo = () => {
      emit("toggle-info");
    };

    watch(
      () => informations.value,
      newVal => {
        const savedState = localStorage.getItem("openItemsState");
        if (savedState) {
          openItems.value = JSON.parse(savedState);
        } else {
          openItems.value = newVal ? newVal.map((_, index) => index === 0) : [];
        }
      },
      { immediate: true }
    );

    const toggleItem = (index: number) => {
      openItems.value[index] = !openItems.value[index];
    };

    watch(
      () => isVisible.value,
      async newVal => {
        if (newVal) {
          await fetchInformations.value();
        }
      }
    );

    onBeforeMount(async () => {
      await fetchInformations.value();
    });

    return {
      isVisible,
      informations,
      filteredInformations,
      openItems,
      toggleInfo,
      toggleItem,
      searchQuery
    };
  }
});
